(function () {
  function decimalPlaces(value) {
    var normalized = String(value).replace(/,/g, '').trim();
    var decimal = normalized.split('.')[1];
    return decimal ? decimal.length : 0;
  }

  function init(section) {
    if (!section || section.dataset.barefootCounterReady === 'true') return;
    section.dataset.barefootCounterReady = 'true';

    var counters = Array.prototype.slice.call(section.querySelectorAll('[data-barefoot-counter]'));
    if (!counters.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration = parseInt(section.dataset.counterDuration, 10) || 1800;

    function showFinalValues() {
      counters.forEach(function (counter) { counter.textContent = counter.dataset.finalValue; });
      section.dataset.barefootCounterAnimated = 'true';
    }

    function animate() {
      if (section.dataset.barefootCounterAnimated === 'true') return;
      section.dataset.barefootCounterAnimated = 'true';
      var startTime = performance.now();

      function frame(now) {
        var progress = Math.min((now - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);

        counters.forEach(function (counter) {
          var finalText = counter.dataset.finalValue;
          var finalNumber = parseFloat(String(finalText).replace(/,/g, ''));
          if (!Number.isFinite(finalNumber)) {
            counter.textContent = finalText;
            return;
          }
          var places = decimalPlaces(finalText);
          counter.textContent = (finalNumber * eased).toFixed(places);
        });

        if (progress < 1) requestAnimationFrame(frame);
        else showFinalValues();
      }

      requestAnimationFrame(frame);
    }

    if (reducedMotion || !('IntersectionObserver' in window)) {
      showFinalValues();
      return;
    }

    counters.forEach(function (counter) {
      var places = decimalPlaces(counter.dataset.finalValue);
      counter.textContent = places ? (0).toFixed(places) : '0';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          observer.unobserve(section);
          animate();
        }
      });
    }, { threshold: [0.35] });

    observer.observe(section);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-barefoot-counter-section]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
